/* eslint-disable no-restricted-properties */
export const formatToLocalDate = (timeStamp) => {
  const formattedDate = new Date(timeStamp)?.toLocaleDateString(
    "en-US",
    {
      // weekday: 'short',
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }
  );
  return formattedDate || "";
};